import { Component } from '@angular/core';
import { HeaderComponent } from "../../layout/header/header.component";
import { FooterComponent } from "../../layout/footer/footer.component";
import { RouterLink } from '@angular/router';
import { JobOpeningsComponent } from './job-openings/job-openings.component';

@Component({
  selector: 'app-careers',
  standalone: true,
  templateUrl: './careers.component.html',
  styleUrl: './careers.component.scss',
  imports: [HeaderComponent, FooterComponent, RouterLink, JobOpeningsComponent]
})
export class CareersComponent {

}
